import React from 'react';

import PropTypes from 'prop-types';

import DesktopSidebar from './components/DesktopSidebar';
import SmallScreenSidebar from './components/SmallScreenSidebar';

function Sidebar({ isMobile, isTablet, openSidebar, handleToggler, handleHelpClick }) {
    return (
        <>
            {!(isMobile || isTablet) && <DesktopSidebar handleHelpClick={handleHelpClick} />}
            <SmallScreenSidebar
                openSidebar={openSidebar}
                handleToggler={handleToggler}
                isMobile={isMobile}
                handleHelpClick={handleHelpClick}
            />
        </>
    );
}

Sidebar.propTypes = {
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    openSidebar: PropTypes.bool,
    handleToggler: PropTypes.func,
    handleHelpClick: PropTypes.func,
};

export default Sidebar;
